import React, {FC, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import {MaterialReactTable, MRT_ColumnDef as MRTColumnDef} from 'material-react-table';
import {Typography} from '@mui/material';
import Moment from 'react-moment';
import PrinterType from '../../../pages/Printers/printerType';

interface ServiceListProps {
  isLoading: boolean;
  services: OverviewService[];
}

export const ServiceList: FC<ServiceListProps> = ({isLoading, services}) => {
  const navigate = useNavigate();

  const columns = useMemo<MRTColumnDef<OverviewService>[]>(() => [
    {
      header: 'Printer ID',
      accessorFn: (row) => row.printer.id,
    },
    {
      header: 'Printer Serial',
      accessorKey: 'printer_serial',
    },
    {
      header: 'Model',
      accessorKey: 'printer_type',
      Cell: ({cell}) => <PrinterType printer={cell.getValue<any>()} />,
    },
    {
      header: 'Installation',
      accessorFn: (row) => row.printer.installation_date,
      Cell: ({cell}) => (
        <Moment format="DD-MM-YYYY">{cell.getValue<string>()}</Moment>
      ),
    },
    {
      header: 'Service Type',
      accessorKey: 'service_type',
    },
    {
      header: 'Number of Prints/Shots/Hours',
      accessorKey: 'number_of_prints',
    },
    {
      header: 'Date of Visit',
      accessorKey: 'date_of_visit',
      Cell: ({cell}) => (
        <Moment format="DD-MM-YYYY">{cell.getValue<string>()}</Moment>
      ),
    },
    {
      header: 'Input',
      accessorKey: 'created_at',
      Cell: ({cell}) => (
        <Moment format="DD-MM-YYYY">{cell.getValue<string>()}</Moment>
      ),
    },
    {
      header: 'Engineer',
      accessorFn: (row) =>
        row.engineer ?
          `${row.engineer.firstname} ${row.engineer.lastname}` :
          '',
    },
    {
      header: 'Dealer',
      accessorFn: (row) => row.dealer?.name ?? '',
    },
  ], []);

  return (
    <MaterialReactTable
      columns={columns}
      data={services}
      enableSorting
      enableColumnFilters
      enablePagination
      enableGlobalFilter
      state={{isLoading}}
      muiTablePaperProps={{
        elevation: 0,
      }}
      muiTableBodyRowProps={({row}) => ({
        onClick: () =>
          navigate(`/printer/${(row.original as any).printer.id}`),
      })}
      renderTopToolbarCustomActions={() =>
        <Typography variant="h6">Services</Typography>
      }
    />
  );
};
